// Фабрика голосовой сессии: мок или реальный WS — по флагу VITE_USE_MOCK.
// UI работает с интерфейсом VoiceSession и не знает, что именно под капотом.

import { config } from '../config'
import type { VoiceSession } from '../types'
import { MockVoiceSession } from './MockVoiceSession'
import { BridgeSession } from './BridgeSession'
import { WebSocketVoiceSession } from './WebSocketVoiceSession'

export function createVoiceSession(): VoiceSession {
  switch (config.backend) {
    case 'bridge':
      return new BridgeSession()
    case 'ws':
      return new WebSocketVoiceSession()
    case 'mock':
    default:
      return new MockVoiceSession()
  }
}
